import { z } from 'zod';
import { zExercise as _zExercise, zExerciseMetric as _zExerciseMetric, zSetMetric as _zSetMetric, zSet as _zSet, } from '../../core';
export const zEditType = z.enum(['initial', 'revert']).nullable();
export const zSetMetric = _zSetMetric.merge(z.object({
    id: z.uuid(),
    workoutSetMetricId: z.uuid(),
}));
export const zSetMetricEdit = _zSetMetric.partial({
    input: true,
    forCollection: true,
    dataSource: true,
    enteredBy: true,
    enteredOn: true,
});
export const zSet = _zSet.merge(z.object({
    id: z.uuid(),
    workoutSetId: z.uuid(),
    metrics: z.array(zSetMetric),
}));
export const zExerciseMetric = _zExerciseMetric.merge(z.object({
    id: z.uuid(),
    workoutExerciseMetricId: z.uuid(),
    benchmarkGridId: z.uuid().optional(),
}));
export const zExercise = _zExercise.merge(z.object({
    id: z.uuid(),
    workoutExerciseId: z.uuid(),
    sets: z.array(zSet),
    metrics: z.array(zExerciseMetric),
}));
//# sourceMappingURL=base.js.map